import { DateTime } from 'luxon';

export default function initAccountDetailsForm() {
    const errorMessages = {
        empty: 'Enter your date of birth.',
        incomplete: 'Date of birth must include a day, a month and a year.',
        invalid: 'Date of birth must be a real date.',
        future: 'Date of birth must be in the past.',
        tooOld: 'Date of birth must be after 1 January 1900.',
        tooYoung: 'Date of birth must be at least 5 years ago. Children under 5 are not eligible.',
    };

    function validateBirthdate() {
        const dayInput = document.getElementById("dob-day");
        const monthInput = document.getElementById("dob-month");
        const yearInput = document.getElementById("dob-year");
        const hiddenInput = document.getElementById("DateOfBirth");
        const errorEl = document.querySelector('[data-valmsg-for="DateOfBirth"]');
        const errorIcon = document.getElementById("dob-validation-icon");

        const day = dayInput.value;
        const month = monthInput.value;
        const year = yearInput.value;
        const inputs = [dayInput, monthInput, yearInput];

        let errorMessage = "";

        const isEmpty = !day && !month && !year;
        const isIncomplete = !day || !month || !year;

        if (isEmpty) {
            errorMessage = errorMessages.empty;
        } else if (isIncomplete) {
            errorMessage = errorMessages.incomplete;
        } else {
            const date = DateTime.fromObject({ day: Number(day), month: Number(month), year: Number(year) });

            const now = DateTime.now();
            const minDate = now.minus({ years: 5 });

            if (!date.isValid) {
                errorMessage = errorMessages.invalid;
            } else if (date.year < 1900) {
                errorMessage = errorMessages.tooOld;
            } else if (date > now) {
                errorMessage = errorMessages.future;
            } else if (date > minDate) {
                errorMessage = errorMessages.tooYoung;
            }
        }

        if (errorMessage) {
            errorEl.textContent = errorMessage;
            errorEl.classList.add("field-validation-error");
            hiddenInput.value = "";
            if (errorIcon) errorIcon.classList.remove("at-d-none");
            inputs.forEach(input => input.classList.add("input-validation-error"));
        } else {
            errorEl.textContent = "";
            errorEl.classList.remove("field-validation-error");

            const formattedDay = String(day).padStart(2, '0');
            const formattedMonth = String(month).padStart(2, '0');
            hiddenInput.value = `${formattedDay}/${formattedMonth}/${year}`;

            if (errorIcon) errorIcon.classList.add("at-d-none");
            inputs.forEach(input => input.classList.remove("input-validation-error"));
        }
    }

    function bindDateOfBirthListeners() {
        ["dob-day", "dob-month", "dob-year"].forEach(id => {
            const input = document.getElementById(id);
            if (!input) return;

            input.addEventListener("blur", validateBirthdate);
            input.addEventListener("keypress", e => {
                const char = String.fromCharCode(e.which || e.keyCode);
                if (!/\d/.test(char)) e.preventDefault();
            });
            input.addEventListener("paste", e => {
                const paste = (e.clipboardData || window.clipboardData).getData("text");
                if (!/^\d+$/.test(paste)) e.preventDefault();
            });
        });
    }

    function prefillDateOfBirthFromHiddenInput() {
        const value = document.getElementById("DateOfBirth").value;
        const match = value.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
        if (match) {
            const [, day, month, year] = match;
            document.getElementById("dob-day").value = day;
            document.getElementById("dob-month").value = month;
            document.getElementById("dob-year").value = year;
        }
    }

    function setupAddressToggle() {
        const addressToggleBtn = document.getElementById("toggle-manual-address");
        const manualFields = document.getElementById("manual-address-fields");

        addressToggleBtn.addEventListener("click", (e) => {
            e.preventDefault();
            manualFields.classList.toggle("visible");

            const useEl = addressToggleBtn.querySelector("svg use");
            const isVisible = manualFields.classList.contains("visible");
            useEl.setAttribute("href", isVisible ? "#icon-chevron-up" : "#icon-chevron-down");
        });
    }

    document.addEventListener("DOMContentLoaded", () => {
        const form = document.getElementById("my-preferences-form");
        const fieldset = document.getElementById("AT_My_Preferences");
        const spinner = document.getElementById("save-spinner");

        bindDateOfBirthListeners();
        prefillDateOfBirthFromHiddenInput();
        setupAddressToggle();

        fieldset.disabled = false;

        form.addEventListener("submit", function (e) {
            if (e.submitter?.value === "Cancel") return;

            validateBirthdate();
            const errorEl = document.querySelector('[data-valmsg-for="DateOfBirth"]');
            if (errorEl && errorEl.textContent.trim() !== "") {
                e.preventDefault();
                errorEl.scrollIntoView({ behavior: "smooth", block: "center" });
                return;
            }

            if (!$("#my-preferences-form").validate().form()) return;

            spinner.classList.remove("at-d-none");
            // Prevent disabling the fieldset before form submission
            requestAnimationFrame(() => { 
              fieldset.disabled = true
            });
        });
    });
}
